module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_2_ES-ffc34c8bbd934ccf64134cf652faa0c5.svg";